import { render, staticRenderFns } from "./ResolvedThreadBar.vue?vue&type=template&id=f64aedf0&scoped=true"
import script from "./ResolvedThreadBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ResolvedThreadBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResolvedThreadBar.vue?vue&type=style&index=0&id=f64aedf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64aedf0",
  null
  
)

export default component.exports